export default "/images/dcb624a1294fc18719617da6890a53bd.avif";